/* eslint-disable  */
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./PrivacyPolicy.css";

const icons = ["🗂️", "⚙️", "🤝", "🔒", "🗄️", "⚖️", "🍪", "🔗", "🔄", "📬"];

const sections = [
  {
    title: "Information We Collect",
    details: `<p>We collect the following personal information when you register and use the UPNMG Portal:</p>
      <ul>
        <li><strong>Identity Information:</strong> Full name, staff ID, Ghana Card number, and date of birth.</li>
        <li><strong>Contact Information:</strong> Phone number and email address.</li>
        <li><strong>Employment Information:</strong> Hospital/facility of work, department, and payroll details.</li>
        <li><strong>Financial Information:</strong> Fund contribution amounts, loan application data, mandate numbers, and deduction records.</li>
        <li><strong>Account Information:</strong> Login credentials (password stored securely as a hash), PIN, and authentication tokens.</li>
        <li><strong>Order Information:</strong> Shopping cart contents, orders placed, and purchase history on the UPNMG Mart.</li>
      </ul>`,
  },
  {
    title: "How We Use Your Information",
    details: `<p>Your information is used strictly for the following purposes:</p>
      <ul>
        <li>To create and manage your UPNMG member account.</li>
        <li>To process your loan applications and track repayments.</li>
        <li>To record and display your fund contributions and deductions.</li>
        <li>To facilitate purchases on the UPNMG Mart and process your orders.</li>
        <li>To send you notifications about your account activity, loan status, and important updates.</li>
        <li>To verify your identity and prevent fraudulent activity.</li>
        <li>To provide customer support when you contact us.</li>
        <li>To communicate with you via the built-in messaging system.</li>
      </ul>`,
  },
  {
    title: "How We Share Your Information",
    details: `<p>UPNMG does not sell, rent, or trade your personal information to third parties. Your data may be shared only in the following limited circumstances:</p>
      <ul>
        <li><strong>UPNMG Administration:</strong> Authorized UPNMG staff and administrators access your data solely to process your requests and manage your membership.</li>
        <li><strong>Payroll & Deductions:</strong> Relevant financial data (e.g., deduction amounts) may be shared with your employer's payroll department to facilitate salary deductions.</li>
        <li><strong>Legal Compliance:</strong> We may disclose information if required by Ghanaian law or a valid legal order.</li>
      </ul>`,
  },
  {
    title: "Data Security",
    details: `<p>We take the security of your personal data seriously. The following measures are in place to protect your information:</p>
      <ul>
        <li>Passwords are stored using secure one-way hashing algorithms and are never stored in plain text.</li>
        <li>All communication between your browser and our servers is protected using HTTPS encryption.</li>
        <li>Authentication is handled via secure Bearer tokens with automatic expiry.</li>
        <li>Your account is protected by a unique PIN for sensitive operations.</li>
        <li>Access to the portal requires email verification to confirm your identity.</li>
        <li>Our servers are hosted in a secured environment with restricted access.</li>
      </ul>`,
  },
  {
    title: "Data Retention",
    details: `<p>We retain your personal data for as long as your membership with UPNMG is active. If you cease to be a member:</p>
      <ul>
        <li>Financial and loan records are retained for a minimum of <strong>7 years</strong> as required by Ghanaian financial regulations.</li>
        <li>Account data may be archived after your membership ends.</li>
        <li>You may request deletion of non-financial personal data by contacting support.</li>
      </ul>`,
  },
  {
    title: "Your Rights",
    details: `<p>As a member, you have the following rights regarding your personal data:</p>
      <ul>
        <li><strong>Right to Access:</strong> You can view most of your personal data directly on the portal under "My Profile".</li>
        <li><strong>Right to Correct:</strong> You may update your contact information through the portal settings or by contacting support.</li>
        <li><strong>Right to Query:</strong> You may contact us to ask how your data is being used.</li>
        <li><strong>Right to Complain:</strong> If you believe your data has been mishandled, you may contact us or escalate to the relevant data protection authority in Ghana.</li>
      </ul>`,
  },
  {
    title: "Cookies & Local Storage",
    details: `<p>The UPNMG Portal uses browser local storage to maintain your login session securely. Specifically:</p>
      <ul>
        <li>Your authentication token is stored in local storage to keep you logged in across page visits.</li>
        <li>We do not use third-party tracking cookies or advertising cookies.</li>
        <li>You can clear your local storage at any time by logging out, which will remove all session data from your device.</li>
      </ul>`,
  },
  {
    title: "Third-Party Links",
    details: `<p>The portal may contain links to external websites such as the UPNMG main website (<strong>upnmg.com</strong>) and your government payslip portal. Please note:</p>
      <ul>
        <li>UPNMG is not responsible for the privacy practices of external websites.</li>
        <li>We encourage you to review the privacy policies of any third-party sites you visit.</li>
      </ul>`,
  },
  {
    title: "Changes to This Policy",
    details: `<p>We may update this Privacy Policy from time to time. When changes are made:</p>
      <ul>
        <li>The updated policy will be available on this page with a revised effective date.</li>
        <li>Significant changes will be communicated via in-portal notifications.</li>
        <li>Continued use of the portal after changes are posted constitutes your acceptance of the updated policy.</li>
      </ul>`,
  },
  {
    title: "Contact Us",
    details: `<p>If you have questions, concerns, or requests relating to this Privacy Policy or your personal data, please reach out:</p>
      <ul>
        <li><strong>Email:</strong> upnmgfund@gmail.com</li>
        <li><strong>Website:</strong> <a href="https://upnmg.com" target="_blank" rel="noreferrer">upnmg.com</a></li>
      </ul>`,
  },
];

function PrivacyPolicy() {
  const history = useHistory();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className="PP">
      {/* ── Navbar ── */}
      <nav className="PP__nav">
        <div className="PP__navInner">
          <img src="/images/dev/logo.png" alt="UPNMG logo" className="PP__logo" />
          <button className="PP__back" onClick={() => history.goBack()}>
            ← Back
          </button>
        </div>
      </nav>

      {/* ── Hero ── */}
      <header className="PP__hero">
        <div className="PP__heroBubble PP__heroBubble--1" />
        <div className="PP__heroBubble PP__heroBubble--2" />
        <div className="PP__heroInner">
          <span className="PP__heroTag">Legal</span>
          <h1 className="PP__heroTitle">Privacy Policy</h1>
          <p className="PP__heroSub">
            Effective: February 25, 2026 &nbsp;·&nbsp; UPNMG Member Portal
          </p>
        </div>
      </header>

      {/* ── Body ── */}
      <main className="PP__main">
        {/* Intro card */}
        <div className="PP__intro">
          <div className="PP__introIcon">🛡️</div>
          <p>
            The <strong>Union of Professional Nurses and Midwives, Ghana (UPNMG)</strong> is
            committed to protecting your privacy. This policy explains what data we
            collect, why we collect it, and the rights you have as a member. By using
            this portal, you agree to the practices described below.
          </p>
        </div>

        {/* Two-column layout */}
        <div className="PP__body">
          {/* Sticky TOC */}
          <aside className="PP__toc">
            <p className="PP__tocLabel">Contents</p>
            <ul>
              {sections.map((s, i) => (
                <li key={i}>
                  <button
                    className={`PP__tocItem ${openIndex === i ? "PP__tocItem--active" : ""}`}
                    onClick={() => {
                      toggle(i);
                      document
                        .getElementById(`pp-section-${i}`)
                        ?.scrollIntoView({ behavior: "smooth", block: "start" });
                    }}
                  >
                    <span className="PP__tocNum">{i + 1}</span>
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          {/* Accordion sections */}
          <section className="PP__sections">
            {sections.map((s, i) => (
              <div
                key={i}
                id={`pp-section-${i}`}
                className={`PP__card ${openIndex === i ? "PP__card--open" : ""}`}
              >
                <button className="PP__cardHead" onClick={() => toggle(i)}>
                  <div className="PP__cardLeft">
                    <span className="PP__cardIcon">{icons[i]}</span>
                    <div>
                      <span className="PP__cardNum">0{i + 1}</span>
                      <h3 className="PP__cardTitle">{s.title}</h3>
                    </div>
                  </div>
                  <span className={`PP__chevron ${openIndex === i ? "PP__chevron--open" : ""}`}>
                    ›
                  </span>
                </button>
                <div className="PP__cardBody">
                  <div dangerouslySetInnerHTML={{ __html: s.details }} />
                </div>
              </div>
            ))}
          </section>
        </div>

        {/* Footer strip */}
        <div className="PP__footer">
          <p>© {new Date().getFullYear()} UPNMG. All rights reserved.</p>
          <a href="https://upnmg.com" target="_blank" rel="noreferrer">
            upnmg.com
          </a>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy;
